import get from 'get-value';
import {distributionWebsocketCommands} from '../../constants/distributionWebsocketCommands';

export const distributionExportTickets = (state = {
    isLoadingExport: false,
    exportRecord: {},
    correlationId: null,
}, action) => {
    switch (action.type) {
        case distributionWebsocketCommands.DISTRIBUTION_EXPORT_GET: {
            return Object.assign({}, state, {isLoadingExport: true});
        }
        case distributionWebsocketCommands.DISTRIBUTION_EXPORT_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            const exportRecord = get(action, 'payload.exportRecord', {default: {}});
            return Object.assign({}, state, {
                isLoadingExport: false,
                exportRecord,
                correlationId,
            });
        }
        case distributionWebsocketCommands.DISTRIBUTION_EXPORT_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {isLoadingExport: false});
        }
        case distributionWebsocketCommands.DISTRIBUTION_EXPORT_CREATE: {
            const exportRecord = {
                created: new Date(),
                status: 'NEW'
            };
            return Object.assign({}, state, {exportRecord});
        }
        case distributionWebsocketCommands.DISTRIBUTION_EXPORT_STATUS:
        case distributionWebsocketCommands.DISTRIBUTION_EXPORT_ERROR: {
            const {correlationId, exportRecord} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {exportRecord, correlationId});
        }
        default:
            return state;
    }
};
